import { createContext } from "react";

export const ContextSaleReport = createContext(null);